import { render, staticRenderFns } from "./centro_custo.vue?vue&type=template&id=80f64f7a"
import script from "./centro_custo.vue?vue&type=script&lang=js"
export * from "./centro_custo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports